import { StyleSheet } from 'aphrodite';
import { aceGray, white } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	searchDescription: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: '0 20px',
		background: white,
		border: `1px solid ${aceGray}`,
		borderRadius: 8,
		fontSize: 14,
		boxSizing: 'content-box',
	},
	newCompany: {
		height: 40,
	},
	right: {
		display: 'flex',
		flexDirection: 'column',
		gap: 12,
		flexGrow: 1,
		width: '100%',
	},
	rightCard: {
		fontSize: 14,
		flex: 1,
		minHeight: 0,
		display: 'flex',
		flexDirection: 'column',
		gap: 12,
	},
	container: {
		height: '100%',
		gap: '1rem',
	},
	searchRow: {
		justifyContent: 'space-between',
	},
	searchControls: {
		flex: 1,
		gap: '1rem',
	},
});
